
/**
 *
 * @returns 生成g-token
 */
export function genToken(str: string): string {
  let hash = 5188;
  for (let i = 0, len = str.length; i < len; ++i) {
    // eslint-disable-next-line no-bitwise
    hash += (hash << 5) + str.charCodeAt(i);
  }
  // eslint-disable-next-line no-bitwise
  return String(hash & 0x7fffffff);
}
